import { ApplicationElement, html } from '../application_element/element.js';
import style from './style.lit.css';

import '../icon/element.js';

/**
 * Tag label with folder icon and name
 *
 * @prop name - Tag name ( string )
 * @prop href - URL
 * @prop color - Color of the folder icon ( number, [10, 20, 30 ... 250], default: 10, optional )
 */
export default class Tag extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    name: { type: String },
    color: { type: Number, reflect: true },
    href: { type: String },
  };

  constructor() {
    super();
    this.color = 10;
  }

  render() {
    return html`
      <a href=${this.href}>
        <ef-icon name="folder"></ef-icon>
        <span class="title">${this.name}</span>
      </a>
    `;
  }
}

customElements.get('ef-tag') || customElements.define('ef-tag', Tag);
